module.exports = __webpack_public_path__ + "img/slide4.27634be7.jpg";